import { clsx } from 'clsx'

import { useI18n } from '../../../i18n/index.js'
import { ResultsView } from '../../SmartSearch.types.js'
import { SearchEntityRow } from '../SmartSearchResults/SearchEntityRow.js'
import { SectionTitle } from '../SmartSearchResults/SectionTitle.js'

import { useSearchHistory } from './hooks/useSearchHistory.js'

type Props = {
  view: ResultsView
}

export const SearchHistory = ({ view }: Props) => {
  const { items } = useSearchHistory()

  const { $t } = useI18n()

  if (!items.length) {
    return null
  }

  return (
    <div className="flex flex-col pb-3 relative">
      <SectionTitle
        title={$t({
          defaultMessage: 'Last visited',
          id: 'SmartSearch.LastVisited',
        })}
        view={view}
        className={clsx('top-0 z-10 bg-surface py-3', {
          sticky: items.length > 1,
        })}
      />

      <div className="px-2">
        {items.map(item => (
          <SearchEntityRow key={item.data.url} item={item} type="history" />
        ))}
      </div>
    </div>
  )
}
